export enum SnackbarType {
  Info = 'info',
  Error = 'error',
}
